/**
 * Created by USER on 2018/11/21.
 */
import React, { Component } from 'react';


export default class SingleSecurityAttacks extends Component {
  render() {
    const {item} = this.props;
    if(item.arrow === 'left') {
      return (
        <li className="single_security_attacks">
          <div>
            <div className="single_security_attacks_content">
              <div>
                <span>{item.time}</span>
                <img src={item.img} alt="lubanso"/>
              </div>
              <span>{item.content}</span>
            </div>
            <i className="security_attacks_arrow" />
            <i className="security_attacks_node" />
          </div>
          <div />
        </li>
      )
    } else {
      return (
        <li className="single_security_attacks single_security_attacks_right">
          <div/>
          <div>
            <i className="security_attacks_node security_attacks_node_right" />
            <i className="security_attacks_arrow security_attacks_arrow_right" />
            <div className="single_security_attacks_content">
              <div>
                <span>{item.time}</span>
                <img src={item.img} alt="lubanso"/>
              </div>
              <span>{item.content}</span>
            </div>
          </div>
        </li>
      )
    }
  }
}